import React from 'react';
import './HomeClassic.css';

/** Fallback route `/` pendant le chargement du chunk HomeClassicWeb (jamais un main vide). */
const HomeClassicLoadingShell: React.FC = () => (
  <main className='home-classic classic-page' aria-busy='true' aria-live='polite'>
    <div className='home-classic__loading-hero' aria-hidden />
    <div className='home-classic__free-banner home-classic__loading-banner' aria-hidden />
    <div className='home-classic__below-fold-skeleton' aria-hidden />
  </main>
);

export default HomeClassicLoadingShell;
